import { Fragment, useCallback, useState, useMemo } from 'react'
import { find } from 'ramda'
import cn from 'classnames'

import PlainDropdown, { PlainDropdownDefitem } from 'app/common/ui-next/plain-dropdown'
import { SaleType } from 'app/dataTypes/dishes/saleType'

import styles from './CellContentSaleType.module.scss'

type Props = {
  id: string
  className?: string
  currentSaleTypeId: string | null
  pending: boolean
  saleTypes: Array<SaleType>
  locked?: boolean
  onChangeSaleType: (value: string) => Promise<boolean>
}

export const CellContentSaleType = ({
  id,
  className,
  pending,
  currentSaleTypeId,
  saleTypes,
  locked,
  onChangeSaleType,
}: Props) => {
  const [disabled, setDisabled] = useState(false)

  const handleChangeSaleType = useCallback(
    async ({ id: value }: { id: string }) => {
      setDisabled(true)
      await onChangeSaleType(value)
      setDisabled(false)
    },
    [onChangeSaleType],
  )

  const currentTitle = useMemo(() => {
    return (find(({ id: saleTypeId }) => saleTypeId === currentSaleTypeId, saleTypes) || {}).title
  }, [currentSaleTypeId, saleTypes])

  return (
    <div className={cn(styles.root, className)}>
      {locked ? (
        <span>
          <span>{currentTitle}</span>
        </span>
      ) : (
        <Fragment>
          <span className={styles.hiddenValue} aria-hidden="true">
            {currentTitle}
          </span>

          <PlainDropdown
            defaultSkin
            id={`saleType_${id}`}
            label="Тип продукции"
            className={styles.content}
            labelClassName="visuallyHidden"
            onChange={handleChangeSaleType}
            disabled={pending || disabled}
            placeholder={
              <PlainDropdownDefitem id="placeholder" disabled={pending || disabled}>
                {'Не задан'}
              </PlainDropdownDefitem>
            }
          >
            {saleTypes.map(({ id: saleTypeId, title }) => (
              <PlainDropdownDefitem
                key={saleTypeId}
                id={saleTypeId}
                selected={saleTypeId === currentSaleTypeId}
                disabled={pending || disabled}
              >
                {title}
              </PlainDropdownDefitem>
            ))}
          </PlainDropdown>
        </Fragment>
      )}
    </div>
  )
}
